import events from '@/hooks/events';
import actions from '../constants';

export default {
  useShowSaveToken: (category, { code }) => events.useDispatchByCode(actions.SHOW_SAVE_TOKEN, category, code),
};
